/*eslint no-use-before-define:0 *///TODO REMOVE THIS
let dd = require('ES/lib/dd');
let _ = require('ES/lib/lodash');
let radio = require('ES/lib/radio');
let Modal = require('ES/widgets/Modal');
let esUtils = require('ES/utils/esUtils');
let FormMixin = require('ES/widgets/forms/FormMixin');
let FormUtils = require('../../../../../utils/FormUtils');
let VenueForm = require('../../../../widgets/venues/VenueForm');
let HorizontalFields = require('ES/widgets/HorizontalFields');
let AccountingLockedWarning = require("../../AccountingLockedWarning");
let EventFormUnsavedChangeMixin = require('../../EventFormUnsavedChangeMixin');

module.exports = dd.createClass({
	__onSubmit: function (data) {
		let event = _.cloneDeep(this.props.event);
		let venue_id = esUtils.toInt(data.venue);
		let stagetime_id = this.props.stagetime_id;
		if (stagetime_id < 1) {
			event.Stagetime = _.values(event.Stagetime);//ensure it's an array
			event.Stagetime.push({id: stagetime_id});
		}
		_.each(event.Stagetime, function (stagetime) {
			if (stagetime.id == stagetime_id) {
				stagetime.description = data.description;
				stagetime.venueid = venue_id;
				stagetime.starttime = data.starttime;
				stagetime.stoptime = data.stoptime;
				stagetime.avchecktime = data.avchecktime;
				stagetime.room = data.room;
				stagetime.breakinfo = data.breakinfo;
			}
		});
		if (venue_id < 1) {
			event.Venue = _.values(event.Venue);//ensure it's an array
			event.Venue.push({id: venue_id});
		}
		_.each(event.Venue, function (venue) {
			if (venue.id == venue_id) {
				venue.address = data.address;
				venue.building = data.building;
				venue.city = data.city;
				venue.country = data.country;
				venue.fax = data.fax;
				venue.phone = data.phone;
				venue.st = data.st;
				venue.timezone = data.timezone;
				venue.zip = data.zip;
			}
		});
		radio('event_schedule_change').broadcast(event);
		radio('save_Event').broadcast(event);
		this.props.onClose();
	},
	render: function () {
		let event = this.props.event;
		let onClose = this.props.onClose;
		let Displaylists = this.props.Displaylists;
		let stagetime_id = this.props.stagetime_id;
		let stagetime = _.first(_.filter(event.Stagetime, function (s) {
			return s.id == stagetime_id;
		}));

		return Modal({
				title: stagetime_id > 0 ? 'Edit Stagetime' : 'New Stagetime',
				onClose: onClose,
				buttons: []
			},
			StagetimeForm({
				event: event,
				stagetime: stagetime,
				Displaylists: Displaylists,
				onSubmit: this.__onSubmit,
				onCancel: onClose
			})
		);
	}
});

let StagetimeForm = dd.createClass({
	mixins: [FormMixin, _.omit(EventFormUnsavedChangeMixin, 'onFormChanged')],
	getInitialState: function () {
		return {show_delete_confirm: false};
	},
	getInitialValuesSourceVersion: function (props) {
		let stagetime = props.stagetime;
		return stagetime && stagetime.id > 0 ? stagetime.id : -1;
	},
	getInitialValues: function (props) {
		let event = props.event;
		let stagetime = props.stagetime || {};

		let default_venue_id = _.first(_.map(_.map(event.Venue, "id"), esUtils.toInt)) || null;
		let venue_id = (stagetime.venueid > 0) ? stagetime.venueid : default_venue_id;

		//new stagetime: default dates to previous stagetime
		if (_.isEmpty(_.get(stagetime, "id"))) {
			stagetime.starttime = undefined;
			_.each(event.Stagetime, function (event_stagetime) {
				if ((undefined == stagetime.starttime) || (_.get(event_stagetime, 'starttime') > stagetime.starttime)) {
					stagetime.starttime = _.get(event_stagetime, 'starttime');
				}
			});
			stagetime.starttime = (undefined == stagetime.starttime) ? new Date(new Date().toDateString()) : new Date(stagetime.starttime.toDateString()); //default to today + and trim time off
			stagetime.stoptime = stagetime.starttime;
		}

		return _.assign({
			description: stagetime.description,
			venue: venue_id,
			starttime: stagetime.starttime,
			stoptime: stagetime.stoptime,
			avchecktime: stagetime.avchecktime,
			room: stagetime.room,
			breakinfo: stagetime.breakinfo
		}, VenueForm.buildInitialValues(event, venue_id));
	},
	buildFields: function () {
		let data = (this.state && this.state.data) || {};
		let event = this.props.event;
		let Displaylists = this.props.Displaylists;

		return _.assign({
			description: {
				label: 'Description',
				type: 'text',
				placeholder: 'Description',
				validate: FormUtils.v.optional
			},
			starttime: {
				label: 'Start',
				type: 'date',
				placeholder: 'Start date and time',
				pick_time: true
			},
			stoptime: {
				label: 'End',
				type: 'date',
				placeholder: 'End date and time',
				pick_time: true,
				valid_range: {
					start: data.starttime
				}
			},
			avchecktime: {
				label: 'A/V check',
				type: 'date',
				placeholder: 'A/V Check date and time',
				pick_time: true,
				valid_range: {
					stop: data.starttime
				},
				validate: FormUtils.v.optional
			},
			room: {
				label: 'Room',
				type: 'text',
				placeholder: 'Room',
				validate: FormUtils.v.optional
			},
			venue: {
				label: 'Venue',
				type: 'select',
				options: _.object(_.map(event.Venue, function (venue) {
					return [venue.id, esUtils.venue_to_string(venue)];
				})),
				placeholder: '-- Add new Venue --',
				validate: FormUtils.v.optional//if nothing is selected, then it's in add a new venue mode
			}
		}, VenueForm.buildFields(Displaylists, data));
	},
	onFormChanged: function (field_path, new_value) {
		let self = this;
		let data = (this.state && this.state.data) || {};
		if (field_path === 'starttime' && _.isDate(new_value)) {
			this.setState({data: data}, function () {
				if (!_.isDate(data.stoptime) || data.stoptime.getTime() < new_value.getTime()) {
					self._form_onChange('stoptime', _.cloneDeep(new_value));
				}
			});
		} else if (field_path === 'venue') {
			this.setState({data: _.assign(data, VenueForm.buildInitialValues(this.props.event, new_value))});
		}
		//from EventFormUnsavedChangeMixin
		this.__checkForChangesMade();
	},
	__toggleDeleteConfirm: esUtils.wrapPreventDefault(function () {
		this.setState({show_delete_confirm: !this.state.show_delete_confirm});
	}),
	__onDelete: esUtils.wrapPreventDefault(function () {
		let event = _.cloneDeep(this.props.event);
		let stagetime = this.props.stagetime;
		if (event && event.eid > 0 && stagetime && stagetime.id > 0) {
			event.Stagetime = _.reject(event.Stagetime, function (s) {
				return s.id == stagetime.id;
			});
			radio('save_Event').broadcast(event);
			this.props.onCancel();
		}
	}),
	render: function () {
		let fields = this.buildFields();
		let errors = this.state.errors || {};
		let {event, onCancel, stagetime} = this.props;
		let buildInput = this._form_buildInput;
		let show_delete_confirm = this.state.show_delete_confirm;

		let buildFields = function (layout) {
			return HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: buildInput,
				scale: 'sm',
				label_size: 2,
				layout: layout
			});
		};

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			buildFields([
				['description'],
				['starttime'],
				['stoptime'],
				['avchecktime'],
				['room']
			]),
			dd.hr(),
			buildFields([
				['venue']
			]),
			dd.br(),
			buildFields(VenueForm.horizontal_fields_layout),
			dd.p({className: 'text-muted text-center', style: {fontStyle: "italic"}},
				"Select venue's timezone, and set times for that timezone."
			),
			show_delete_confirm ? dd.div(null,
				dd.div({className: 'alert alert-danger'},
					dd.div(null, dd.strong(null, 'Are you sure'), ' you want to delete this stagetime?'),
					dd.button({className: 'btn btn-danger', onClick: this.__onDelete}, 'Yes, delete'),
					' ',
					dd.button({className: 'btn btn-default', onClick: this.__toggleDeleteConfirm}, 'No, don\'t delete')
				)
			) : HorizontalFields.FormButtons({
				label_size: 3,
				submit_btn_text: stagetime && stagetime.id > 0 ? 'Save' : 'Add',
				onDiscard: stagetime && !_.isFunction(onCancel) ? this.__discardChanges : null,
				onCancel: onCancel,
				onDelete: (stagetime && stagetime.id > 0) ? this.__toggleDeleteConfirm : null,
				right_align_buttons: true
			}),
			AccountingLockedWarning({event})
		);
	}
});


// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/StagetimeModal.js